export default "__VITE_ASSET__8dtasojf__";